import type { ReactElement } from "react";

import type { PrimeLogoProps } from "~/components/common/PrimeLogo/contract";

export interface WaitingMessageCommonProps {
  translatedTitle?: string;
  translatedDescription: string | ReactElement;
  showLogo?: boolean;
}

export interface WaitingMessageProps extends WaitingMessageCommonProps {
  isMobile?: boolean;
}

export interface WaitingMessageStyleProps {
  logo: {
    margin: "3x_big" | "big";
    dataTestId: string;
    type: PrimeLogoProps["type"];
  };
  title: {
    margin: "big" | "base";
  };
  description: {
    padding: "2x_huge" | "small";
  };
}

export const PRIME_LOGO_TEST_ID = "waiting-message-prime-logo-long";
export const PRIME_LOGO_SHORT_TEST_ID = "waiting-message-prime-logo-short";
export const WAITING_MESSAGE_TEST_ID = "waiting-message";
